"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEventInfoFromOrder = exports.getLinkUrl = exports.getOrdersInRange = void 0;

var _dates = require("./dates");

/**
 * Given an array of attendee orders, determine if the next upcoming order
 * is within a provided range.
 *
 * An order is considered within the range if the event's start time is within
 * the provided time range, and the event is currently live.
 *
 * @param {array} orders An array of the current logged in user's orders
 * @param {number} timeRange A number representing number of hours ahead of an order we want to show a banner to their upcoming event
 *
 * @return {array} Array of orders that match the passed in timeRange sorted by event start time
 */
var getOrdersInRange = function getOrdersInRange(orders) {
  var timeRangeInHours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 24;

  if (!orders || orders.length === 0) {
    return [];
  }

  var ordersInRange = orders.filter(function (order) {
    var _order$event$start, _order$event;

    var _ref = (_order$event$start = order === null || order === void 0 ? void 0 : (_order$event = order.event) === null || _order$event === void 0 ? void 0 : _order$event.start) !== null && _order$event$start !== void 0 ? _order$event$start : {},
        utc = _ref.utc;

    if (utc) {
      var timeRangeInMilliseconds = timeRangeInHours * 60 * 60 * 1000;
      var timeRangeFromNow = new Date(Date.now() + timeRangeInMilliseconds);
      var localizedStartDate = (0, _dates.getLocalizedTime)(utc);
      return localizedStartDate.valueOf() <= timeRangeFromNow.valueOf();
    }

    return false;
  });
  var sortedOrdersInRange = ordersInRange.sort(function (orderA, orderB) {
    var dateA = orderA.event.start.utc;
    var dateB = orderB.event.start.utc;
    var localizedDateA = (0, _dates.getLocalizedTime)(dateA);
    var locasedDateB = (0, _dates.getLocalizedTime)(dateB);
    return Date.parse(localizedDateA).valueOf() - Date.parse(locasedDateB).valueOf();
  });
  return sortedOrdersInRange.length > 0 ? sortedOrdersInRange : [];
};

exports.getOrdersInRange = getOrdersInRange;

var getLinkUrl = function getLinkUrl(orderId, event) {
  var _event$has_digital_co, _event$has_digital_co2;

  var hasDigitalContent = event === null || event === void 0 ? void 0 : (_event$has_digital_co = event.has_digital_content) === null || _event$has_digital_co === void 0 ? void 0 : _event$has_digital_co.has_digital_content;
  var digitalContentUrl = event === null || event === void 0 ? void 0 : (_event$has_digital_co2 = event.has_digital_content) === null || _event$has_digital_co2 === void 0 ? void 0 : _event$has_digital_co2.digital_content_url;

  if (hasDigitalContent && digitalContentUrl) {
    return digitalContentUrl;
  }

  return "/mytickets/".concat(orderId);
};

exports.getLinkUrl = getLinkUrl;

var getEventInfoFromOrder = function getEventInfoFromOrder() {
  var _event$has_digital_co3;

  var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var event = order.event;

  if (!event) {
    return {};
  }

  var id = event.id,
      start = event.start.utc;
  var localizedStartTime = (0, _dates.getLocalizedTime)(start);
  var formattedLocalStart = localizedStartTime ? localizedStartTime.format() : '';
  return {
    hasDigitalContent: event === null || event === void 0 ? void 0 : (_event$has_digital_co3 = event.has_digital_content) === null || _event$has_digital_co3 === void 0 ? void 0 : _event$has_digital_co3.has_digital_content,
    ctaLinkUrl: getLinkUrl(order.id, event),
    start: formattedLocalStart,
    eventName: event.name.text,
    eventId: id
  };
};

exports.getEventInfoFromOrder = getEventInfoFromOrder;
//# sourceMappingURL=orders.js.map